<kendo-stacklayout gap="30" orientation="horizontal" style="height:100%">
  <img #backgroundImage style="display:none" />
  @if(showResetPasswordScreen){
    <div class="background">
      <div class="container">
        <kendo-card class="i-card">
          <form [formGroup]="sendPasswordResetEmailForm" (ngSubmit)="onSubmit()">
            <div class="header">
              <img class="headerImg" src="../../../../assets/images/epclogo.png" />
              <h3 class="headerText">EPC Redeployment Password Reset</h3>
            </div>
            <div class="card-body">
              @if(submitted && showResetPasswordErrorMessage != undefined){
                <div>
                  <span class="show-Reset-Password-validation">{{showResetPasswordErrorMessage}}</span>
                </div>
              }
              <div class="form-row">
                <div class="form-group col">
                  <label>Email</label>
                  <kendo-textbox class="form-textbox" formControlName="email"></kendo-textbox>
                  @if(submitted && f['email'].errors){
                  <div class="k-tooltip-validation">
                    @if(f['email'].errors['required']){
                    <div class="validationMsg">Email is required</div>
                    }
                  </div>
                  }
                </div>
              </div>
            </div>
            <div class="card-footer">
              <button kendoButton type="submit" class="primary btnSendLink">
                Send Link
              </button>
              <p style="text-align: center;">Please submit the email associated with your account. Once you receive the email, it will ask to follow the link to reset your password.</p>
              <p style="text-align: center;">Thank you!</p>
            </div>
          </form>
        </kendo-card>
      </div>
    </div>
  }
</kendo-stacklayout>
